import { MenuItemWithQuantity } from '@/app/store';

export const getOrderItemsFromMenuItems = (
  menuItems: MenuItemWithQuantity[],
  unavailableProductIds?: string[],
) => {
  const availableMenuItems = unavailableProductIds
    ? menuItems.filter((menuItem) => !unavailableProductIds.includes(menuItem.product.id))
    : menuItems;

  return availableMenuItems.flatMap((mi) =>
    mi.variants
      ? mi.variants.map((v) => ({ menuItemId: mi.product.id, quantity: v.quantity, variantId: v.value.id }))
      : [{ menuItemId: mi.product.id, quantity: mi.quantity }],
  );
};
